import { render, staticRenderFns } from "./beneficiary-view.vue?vue&type=template&id=7e34690a&"
import script from "./beneficiary-view.vue?vue&type=script&lang=js&"
export * from "./beneficiary-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports